<template lang="pug">
  .component-vehicle-replace-action-buttons
    .button-group.small.text-center
      button.button.small(type="button", @click="$emit('cancelAndBook',item)") Cancel & Book
      button.button.small(type="button", @click="$emit('voidAndBook', item)") Void & Book
</template>
<script type="text/babel">
  import KeplerBackofficeSdk from 'src/lib/kepler/backoffice'
  import MaggieHelper from "src/maggieHelper"
  import VehicleSmartEdit from "components/backoffice/smartedits/VehicleEdit"

  export default {
    name: "VehicleReplaceButtons",
    components: {VehicleSmartEdit},
    data() {
      return {
        entity: null
      }
    },
    created() {

    },
    methods: {},
    props: ['item']
  }
</script>
<style lang="sass" rel="stylesheet/sass">

</style>



// WEBPACK FOOTER //
// VehicleReplaceButtons.vue?30e90aa0